import { logger } from "../core/logger";

export function initCollectionNav() {
  const nav = document.querySelector("#collection-nav");
  if (!nav) return;

  const OFFSET = parseInt(nav.dataset.offset || 80, 10);

  const stickyHeader = document.querySelector("sticky-header");
  const sentinel = document.getElementById("collection-nav-sentinel");
  const links = document.querySelectorAll(".tag_link");
  const sections = document.querySelectorAll("[data-category]");
  const scrollContainer = nav.querySelector(".ziggy-scrollbar");

  function scrollNavToLink(link) {
    if (!link || !scrollContainer) return;

    const containerRect = scrollContainer.getBoundingClientRect();
    const linkRect = link.getBoundingClientRect();

    const currentScroll = scrollContainer.scrollLeft;
    const linkCenter =
      linkRect.left - containerRect.left + currentScroll + linkRect.width / 2;
    const targetScroll = linkCenter - containerRect.width / 2;

    scrollContainer.scrollTo({
      left: Math.max(0, targetScroll),
      behavior: "smooth",
    });
  }

  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      const target = document.getElementById("category_" + link.dataset.target);
      if (!target) return;

      stickyHeader?.dispatchEvent(
        new CustomEvent("preventHeaderReveal", { bubbles: true }),
      );

      const y = target.getBoundingClientRect().top + window.scrollY - OFFSET;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });

      scrollNavToLink(link);
    });
  });

  if (sections.length && links.length) {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          links.forEach((l) => l.classList.remove("active"));

          const activeLink = document.querySelector(
            `.tag_link[data-target="${entry.target.dataset.category}"]`,
          );

          if (activeLink) {
            activeLink.classList.add("active");
            scrollNavToLink(activeLink);
          }
        });
      },
      {
        rootMargin: "-100px 0px -60% 0px",
      },
    );

    sections.forEach((section) => sectionObserver.observe(section));
  }

  if (nav && sentinel) {
    const stickyObserver = new IntersectionObserver(
      ([entry]) => {
        nav.classList.toggle("is-sticky", !entry.isIntersecting);
      },
      { threshold: 0 },
    );

    stickyObserver.observe(sentinel);
  }
}
